import React, {Component} from 'react';
import {Modal, Radio, Toast} from 'antd-mobile';
import "./style.less";
import connect from "react-redux/es/connect/connect";
import {walletBalance} from "../../service/homeService";
@connect(
    state => ({userInfo: state.userInfo})
)
export default class PayModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payData:[
                // {name:"工商银行支付",text:"",icon:"icon iconfont icongongshangyinhang"},
                {name:"微信支付",text:"亿万用户的选择，更快更安全",icon:"icon iconfont iconweixin"},
                // {name:"民途钱包余额支付",text:"如余额不足，暂时无法支付",icon:"icon iconfont iconzhanghu"},
            ],
            payVal:"",
            balance:"",
        };
    }
    componentDidMount(){
        // if(this.props.businessType == "intercity"){
        //     walletBalance({token:this.props.userInfo.token,source:1}).then((res)=>{
        //         if(res.data.code === '0000'){
        //             this.setState({balance:res.data.data.balance,})
        //         }else{
        //             Toast.info(res.data.msg)
        //         }
        //     });
        // }

    }
    other(res){
        if(res.name == '工商银行支付'){
            return <i className="icon iconfont icontuijian" />
        }
        if(res.name == '民途钱包余额支付'){
            return <span style={{color:'red'}}>{'￥'+this.props.balance}</span>
        }
    }
    render(){
        return(
            <Modal
                popup
                className="payModal"
                visible={this.props.modal}
                onClose={() => this.props.onClose()}
                maskClosable={false}
                animationType="slide-up"
            >
                <div className="warps">
                    <div className="tit">
                        <span>选择支付方式</span>
                        <i className="icon iconfont iconchacha" onClick={()=>this.props.onClose()}/>
                    </div>
                    <div className="con">
                        <div className="payBox">
                            {this.state.payData.map((res, i) => {
                                if(this.props.businessType == undefined && i == 2){
                                    return
                                }else if(i == 2 && this.props.userInfo.signStatus == 0){
                                        return <div className="box wx" key={i} style={{opacity:0.5}}>
                                            <i className={res.icon} />
                                            <div className="text">
                                                <p>{res.name}</p>
                                                <p className="bottom">请前往账户签约后选择钱包支付</p>
                                            </div>
                                        </div>
                                    }else{
                                        return <Radio className="my-radio" key={i} checked={this.state.payVal === res.name}
                                                      onChange={() => this.setState({payVal: res.name})}>
                                            <div className="box wx">
                                                <i className={res.icon} />
                                                <div className="text">
                                                    <p>{res.name} {this.other(res)}</p>
                                                    <p className="bottom">{res.text}</p>
                                                </div>
                                            </div>
                                        </Radio>
                                    }
                                })}
                        </div>
                        <div className="btn" onClick={()=>this.props.payType(this.state.payVal)}><button>确认支付</button></div>
                    </div>
                </div>

            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PayModal/index.js